var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"secondWrap"},[_c('GoBack',{attrs:{"title":_vm.title}}),(_vm.isShow)?_c('van-loading',[_vm._v("加载中...")]):_c('div',{staticStyle:{"height":"100%","background":"#fff"}},[(_vm.isDefault)?_c('RegisterDefault',{on:{"setIsDefault":_vm.setIsDefault}}):_c('Registered')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }